import React from "react";

import {Styles} from './style/coinPanelStyle'

const CoinPanel = (props) => {
  const { coin, icon, iconLabel, showIcon = true, title, percentage, displayPrice, unit = "تومان" } = props

  return (
    <Styles>
      <div className="coin-panel">
        <div className="main">
          {showIcon && (
            <div className="coin">
              {icon ? (
                <span className="flag-icon" role="img" aria-label={iconLabel}>{icon}</span>
              ) : (
                <img src={coin || "/image/empty_coin.png"} alt="coin" />
              )}
            </div>
          )}
          <div className="content">
            <div className="coin-title">{ title }</div>
          </div>
        </div>
        <div className="status">

          <div className="percentage">{displayPrice ?? percentage} {unit}</div>
        </div>
      </div>
    </Styles>
  )
}
export default CoinPanel
